import { NgModule, Optional, SkipSelf } from '@angular/core';

import { throwIfAlreadyLoaded } from './dev';
import { EnvironmentOverviewGuard, PreferencesGuard, SubmissionGuard } from './guards';
import { AuthenticationModule } from './authentication';
import { DashboardGuard } from './guards/dashboard.guard';

const guards = [EnvironmentOverviewGuard, PreferencesGuard, SubmissionGuard, DashboardGuard];
const modules = [AuthenticationModule];

@NgModule({
  imports: [...modules],
  exports: [AuthenticationModule],
  providers: [...guards]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
